/**
 * Created by tigran on 18.01.25
 **/

import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

type HomeIconProps = IconType & {
  variant?: 'default' | 'table';
};

export const HomeIcon: FC<HomeIconProps> = (props) => {
  const { width, height, color, variant = 'default' } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  const isTable = variant === 'table';

  return (
    <svg
      width={width}
      height={height}
      viewBox={isTable ? '0 0 21 20' : '0 0 16 17'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d={
          isTable
            ? 'M2.39307 9.28575L10.2502 2.85718L18.1074 9.28575'
            : 'M1.71436 7.74271L8.00007 2.59985L14.2858 7.74271'
        }
        stroke={color}
        strokeWidth={isTable ? 1.71429 : 1.37143}
        strokeMiterlimit={10}
      />
      <path
        d={
          isTable
            ? 'M8.82129 17.8572L8.82129 13.5715H11.6784V17.8572'
            : 'M6.85718 14.6L6.85718 11.1714H9.14289V14.6'
        }
        stroke={color}
        strokeWidth={isTable ? 1.71429 : 1.37143}
        strokeMiterlimit={10}
      />
      <path
        d={
          isTable
            ? 'M4.53564 10.7144L4.53564 16.4286C4.53564 17.2179 5.17493 17.8572 5.96422 17.8572L14.5356 17.8572C15.3249 17.8572 15.9642 17.2179 15.9642 16.4286L15.9642 10.7144'
            : 'M3.42847 8.88574L3.42847 13.4572C3.42847 14.0886 3.9399 14.6 4.57132 14.6L11.4285 14.6C12.0599 14.6 12.5713 14.0886 12.5713 13.4572L12.5713 8.88574'
        }
        stroke={color}
        strokeWidth={isTable ? 1.71429 : 1.37143}
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
    </svg>
  );
};
